import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import * as SecureLS from "secure-ls";
import { StorageService } from "../../services/storage.service";
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  role: any;
}
import { NgbTooltipConfig } from "@ng-bootstrap/ng-bootstrap";
import { roleIdSix } from "src/app/shared/constants/role.id.constants";
export class NgbdTooltipConfig {
  constructor(config: NgbTooltipConfig) {
    // customize default values of tooltips used by this component tree
    config.placement = "right";
    config.triggers = "click";
  }
}

/*dashboard*/
export const ROUTES: RouteInfo[] = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: "../../../assets/img/icons/common/dashboard.svg",
    class: "pr-4",
    role: "",
  },
  {
    path: "/student-video",
    title: "Advance Search Video",
    icon: "../../../assets/img/icons/common/advance-search-video.svg",
    class: "pr-4",
    role: "5",
  },
  {
    path: "/my-department-classes",
    title: "My department",
    icon: "../../../assets/img/icons/common/scheduling.svg",
    class: "pr-4",
    role: "5",
  },
  {
    path: "/professor-video",
    title: "Advance Search Video",
    icon: "../../../assets/img/icons/common/advance-search-video.svg",
    class: "pr-4",
    role: "4",
  },
  {
    path: "/upcoming-schedule",
    title: "Upcoming Schedules",
    icon: "../../../assets/img/icons/common/scheduling.svg",
    class: "pr-4",
    role: "4",
  },
  {
    path: "/pending",
    title: "Pending Approval",
    icon: "../../../assets/img/icons/common/pending-approval.svg",
    class: "pr-4",
    role: "4",
  },
  {
    path: "/approved",
    title: "Professor Approved Videos",
    icon: "../../../assets/img/icons/common/film-solid.svg",
    class: "pr-4",
    role: "4",
  },
  {
    path: "/class/onlive/list",
    title: "Live Stream Classes",
    icon: "../../../assets/img/icons/common/camera.svg",
    class: "pr-4",
    role: "4",
  },
  {
    path: "/class/onlive/list",
    title: "Live Stream Classes",
    icon: "../../../assets/img/icons/common/camera.svg",
    class: "pr-4",
    role: "5",
  },
];

/*master records menu*/
export const MASTER: RouteInfo[] = [
  {
    path: "/session-master",
    title: "Session Master",
    icon: "../../../assets/img/icons/submenu-latest-icon/session_master.svg",
    class: "pr-4 ",
    role: "2",
  },
  {
    path: "/course",
    title: "Course",
    icon: "../../../assets/img/icons/submenu-latest-icon/course.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/department",
    title: "Department",
    icon: "../../../assets/img/icons/submenu-latest-icon/department.svg",
    class: "pr-4",
    role: "2",
  },

  {
    path: "/subjects",
    title: "Subjects",
    icon: "../../../assets/img/icons/submenu-latest-icon/subject.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/batch",
    title: "Batch",
    icon: "../../../assets/img/icons/submenu-latest-icon/batch.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/classroom",
    title: "Classroom",
    icon: "../../../assets/img/icons/submenu-latest-icon/classrroom.svg",
    class: "pr-4 ",
    role: "2",
  },
];

/*Device setup menu */
export const DEVICE: RouteInfo[] = [
  {
    path: "/camera",
    title: "Camera",
    icon: "../../../assets/img/icons/submenu-latest-icon/camera.svg",
    class: "pr-4 menu-txt-color",
    role: "2",
  },
  {
    path: "/audio-device",
    title: "Audio Devices",
    icon: "../../../assets/img/icons/submenu-latest-icon/audio device.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/raspberry-device",
    title: "Raspberry Devices",
    icon: "../../../assets/img/icons/submenu-latest-icon/raspberry devices.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/hardware-mapping",
    title: "Hardware Mapping",
    icon: "../../../assets/img/icons/submenu-latest-icon/hardware.svg",
    class: "pr-4 font-size-14",
    role: "2",
  },
  {
    path: "/health-checkup",
    title: "Health Checkup",
    icon: "../../../assets/img/icons/submenu-latest-icon/hardware mapping.svg",
    class: "pr-4 font-size-14",
    role: "2",
  },
  {
    path: "/file-server",
    title: "File Server",
    icon: "../../../assets/img/icons/submenu-latest-icon/department.svg",
    class: "pr-4 font-size-14",
    role: "2",
  },
];

/*User Management & Scheduling*/
export const USERMANAGEMENT: RouteInfo[] = [
  {
    path: "/user",
    title: "Admin Management",
    icon: "../../../assets/img/icons/submenu-latest-icon/user management.svg",
    class: "pr-3",
    role: "2",
  },
  {
    path: "/professor",
    title: "Professor/Trainer Management",
    icon: "../../../assets/img/icons/submenu-latest-icon/professor-management.svg",
    class: "pr-3",
    role: "2",
  },
  {
    path: "/student",
    title: "Learner Management",
    icon: "../../../assets/img/icons/submenu-latest-icon/student-management.svg",
    class: "pr-3",
    role: "2",
  },
  {
    path: "/customer",
    title: "Customer Management",
    icon: "../../../assets/img/icons/submenu-latest-icon/user management.svg",
    class: "pr-3",
    role: "1",
  },

  {
    path: "/timetable",
    title: "Time Table",
    icon: "../../../assets/img/icons/submenu-latest-icon/event-note.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/video-details",
    title: "Schedule",
    icon: "../../../assets/img/icons/submenu-latest-icon/scheduling.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/class/onlive/list",
    title: "Live Stream Classes",
    icon: "../../../assets/img/icons/submenu-latest-icon/play-lesson.svg",
    class: "pr-4",
    role: "2",
  },

  {
    path: "/pending",
    title: "Pending Approval",
    icon: "../../../assets/img/icons/submenu-latest-icon/pending-approval.svg",
    class: "pr-4",
    role: "2",
  },
];

/*Report*/
export const Report: RouteInfo[] = [
  {
    path: "/video-report",
    title: "InActive Schedules",
    icon: "../../../assets/img/icons/submenu-latest-icon/pending.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/video-access-report",
    title: "Video Access Report",
    icon: "../../../assets/img/icons/submenu-latest-icon/video-report.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/audio-report",
    title: "Audio Report",
    icon: "../../../assets/img/icons/submenu-latest-icon/audio-report.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/nonaudible-report",
    title: "Non Audible Report",
    icon: "../../../assets/img/icons/submenu-latest-icon/volume_off2.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/nonapproval-report",
    title: "Non Approval Report",
    icon: "../../../assets/img/icons/submenu-latest-icon/volume_off3.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/video-list",
    title: "Error Log Report",
    icon: "../../../assets/img/icons/submenu-latest-icon/assignment.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/summary-report",
    title: "Daily Summary",
    icon: "../../../assets/img/icons/submenu-latest-icon/description_black.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/daily-report",
    title: "Overall Summary",
    icon: "../../../assets/img/icons/submenu-latest-icon/description_black.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/department-summary",
    title: "Department Summary",
    icon: "../../../assets/img/icons/submenu-latest-icon/description_black.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/staff-usage-report",
    title: "Staff Usage Report",
    icon: "../../../assets/img/icons/submenu-latest-icon/description_black.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/detailed-staff-usage-report",
    title: "Detailed Staff Usage Report",
    icon: "../../../assets/img/icons/submenu-latest-icon/description_black.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/report-login",
    title: "Login Report",
    icon: "../../../assets/img/icons/submenu-latest-icon/description_black.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/schedule-history",
    title: "Schedule History ",
    icon: "../../../assets/img/icons/submenu-latest-icon/history.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/student-existing",
    title: "Learners Login Expiry List",
    icon: "../../../assets/img/icons/submenu-latest-icon/list.svg",
    class: "pr-4",
    role: "2",
  },
  {
    path: "/approved-videos",
    title: "Approved Videos",
    icon: "../../../assets/img/icons/submenu-latest-icon/pending.svg",
    class: "pr-4",
    role: "2",
  },
];

@Component({
  selector: "app-adminsidebar",
  templateUrl: "./adminsidebar.component.html",
  styleUrls: ["./adminsidebar.component.css"],
})
export class AdminSidebarComponent implements OnInit {
  public menuItems: any[];
  public menuItems1: any[];

  public menuItems2: any[];
  public menuItems3: any[];
  public menuItems4: any[];
  public menuItems5: any[];
  public isCollapsed = true;
  private ls = new SecureLS({ encodingType: "aes" });
  firstname = this.ls.get("first_name");
  lastname = this.ls.get("last_name");
  roleId;
  isLoginType: boolean;
  report_permission: number = 1;
  hod: any;
  isShowOnlySchedule = false;
  constructor(
    private storageService: StorageService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    if (this.ls.get("report_permission") != undefined) {
      this.report_permission = this.ls.get("report_permission");
    }
    if (this.storageService.getRole() === roleIdSix) {
      this.isShowOnlySchedule = true;
    }
  }

  ngOnInit() {
    this.hod = this.storageService.getHod();
    if (this.ls.get("live_class_permission") == 0) {
      this.menuItems = ROUTES.filter((menuItem) => menuItem).splice(0, 5);
    } else {
      this.menuItems = ROUTES.filter((menuItem) => menuItem);
    }
    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
    });

    /*master records category*/
    this.menuItems1 = MASTER.filter((menuItem1) => menuItem1);
    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
    });
    /*device setup */
    this.menuItems2 = DEVICE.filter((menuItem2) => menuItem2);
    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
    });

    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
    });

    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
    });
    this.route.queryParams.subscribe((params) => {
      this.isLoginType = !!params["loginType"];
      if (params.loginType == "impersonate") {
        this.roleId = this.ls.get("impersonate_role");
      } else {
        this.roleId = this.ls.get("role");
      }

      /*user management */
      if (this.ls.get("live_class_permission") == 0) {
        this.menuItems3 = USERMANAGEMENT.filter(
          (menuItem3) => menuItem3
        ).splice(0, 6);
      } else {
        this.menuItems3 = USERMANAGEMENT.filter((menuItem3) => menuItem3);
      }
      if (this.roleId == 4 && this.hod == 1) {
        this.menuItems3.splice(0, 1);
        this.menuItems3.splice(3, 1);
        this.menuItems3.splice(4, 1);
      }

      /*Report */
      const excludedIndices = [5, 12];
      // this.menuItems4 = Report.filter((menuItem4) => menuItem4);
      // let errorLogIndex = Report.findIndex(
      //   (elem) => elem.title === "Error Log Report"
      // );
      // if (this.roleId == 4 && this.hod == 1) {
      //   this.menuItems4.splice(errorLogIndex, 1);
      // }
      // if (this.roleId === 4 && this.hod !== 1) {
      //   this.menuItems4 = Report.filter(
      //     (menuItem, index) => !excludedIndices.includes(index)
      //   );
      // }
      this.menuItems4 = Report.filter((menuItem4) => menuItem4);

      if (this.roleId === 4) {
        this.menuItems4 = Report.filter(
          (menuItem) =>
            menuItem.path === "/video-access-report" ||
            menuItem.path === "/audio-report"
        );
      }
    });
  }
    adjustSubmenu(event: MouseEvent): void {
    const parent = event.currentTarget as HTMLElement;
    const submenu = parent.querySelector('.subdrop') as HTMLElement;

    if (!submenu) return;

    // Reset previous styles
    submenu.style.maxHeight = '';
    submenu.style.overflowY = '';

    // Parent menu position
    const parentRect = parent.getBoundingClientRect();

    // Space available from parent menu to viewport bottom
    const availableHeight = window.innerHeight - parentRect.top - 10;

    // Actual submenu height
    const submenuHeight = submenu.scrollHeight;

    if (submenuHeight > availableHeight) {
      submenu.style.maxHeight = `${availableHeight}px`;
      submenu.style.height = `${availableHeight}px`;
      submenu.style.overflowY = 'auto';
    }
  }
}
